<template>
  <div class="link-attachment">
    <a
      v-if="attachment.url"
      :href="attachment.url"
      target="_blank"
      class="link-attachment__card"
      @click.stop
    >
      <div class="link-attachment__icon-wrapper">
        <Icon icon="mdi:link-variant" class="link-attachment__icon" />
      </div>
      <div class="link-attachment__content">
        <span class="link-attachment__text">{{ attachment.name || attachment.url }}</span>
        <span class="link-attachment__url">{{ getDomainFromUrl(attachment.url) }}</span>
      </div>
      <Icon icon="mdi:open-in-new" class="link-attachment__external" />
    </a>
  </div>
</template>

<script setup lang="ts">
import type { Attachment } from "@/dtos/Unipile.dto";
import { Icon } from "@iconify/vue";

interface Props {
  attachment: Attachment;
}

defineProps<Props>();

const getDomainFromUrl = (url: string): string => {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.replace("www.", "");
  } catch {
    return url;
  }
};
</script>

<style scoped>
.link-attachment {
  position: relative;
  max-width: 300px;
}

.link-attachment__card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  text-decoration: none;
  color: inherit;
  transition: all 0.2s ease;
}

.link-attachment__card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-color: #3b82f6;
}

.link-attachment__icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #eff6ff;
  border-radius: 10px;
  flex-shrink: 0;
}

.link-attachment__icon {
  font-size: 1.25rem;
  color: #3b82f6;
}

.link-attachment__content {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  flex: 1;
  min-width: 0;
}

.link-attachment__text {
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.link-attachment__url {
  font-size: 0.75rem;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.link-attachment__external {
  font-size: 1rem;
  color: #9ca3af;
  flex-shrink: 0;
  transition: color 0.2s;
}

.link-attachment__card:hover .link-attachment__external {
  color: #3b82f6;
}
</style>
